import styled from "styled-components";

import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

export const Annotation = styled(Text)(({ theme }) => ({
    padding: `0 ${theme.spacing.large}`,
    textAlign: "center",
    textTransform: "capitalize",
}));

export const Address = styled(Text)(() => ({
    padding: `8px 48px 0`,
}));
